import {
  COMPANY_OWNERSHIP_TYPE,
  COMPANY_TYPE,
  CompanyBase,
  DateString
} from "@arbolus-technologies/models/common";

import { RELATIONSHIP_TYPE } from "../enums/companiesEnums";
import { CompaniesPaginatedResponse } from "./api";

export interface CompanyHeadquarter {
  address: string | null;
  cityText: string | null;
  cityId: string | null;
  state: string | null;
  countryId: string | null;
  regionId: string | null;
  zipCode: string | null;
}

export interface CompanyCompetitor {
  companyId: string;
  name: string;
  website: string;
  logoUrl: string;
}

export interface CompanyRelationship {
  parent?: CompanyBase;
  type: RELATIONSHIP_TYPE;
}

export interface Company extends CompanyBase {
  type?: COMPANY_TYPE;
  expertCount?: number;
  isDnc?: boolean;
  linkedinUrl?: string;
  linkedinUrn?: string;
  website?: string;
  relationship: CompanyRelationship;
  doNotContactUpdatedUserId?: string | null;
  doNotContactUpdatedDate?: DateString | null;
  doNotContactUpdatedByUserFullName?: string | null;
  doNotContactKeywords?: string[];
  industryId?: string;
  isDisabled?: boolean;
  description?: string | null;
  revenue?: number | null;
  totalEmployees?: number | null;
  foundationYear?: number | null;
  specialities?: string[] | null;
  ownershipType?: COMPANY_OWNERSHIP_TYPE | null;
  exchangeTicker?: string | null;
  // Single classification enums. Values are backend enum names (e.g. "Fintech")
  // sourced from the client-user company preference reference data.
  sector?: string | null;
  businessModel?: string | null;
  regionName?: string | null;
  headquarter?: CompanyHeadquarter | null;
  competitors?: CompanyCompetitor[] | null;
}

export interface CompanyItem extends CompanyBase {
  insightsApprovedCount?: number;
  website?: string | null;
  isDisabled?: boolean;
  hasCustomerReport?: boolean;
}

export type GetCompaniesResponse = CompaniesPaginatedResponse<Company>;

export type GetUsersCompaniesResponse = CompaniesPaginatedResponse<CompanyItem>;

export enum LIST_COMPANIES_ORDER_BY {
  Name = "Name",
  Website = "Website",
  Type = "Type",
  RelationshipType = "Relationship",
  Industry = "Industry",
  LinkedinUrn = "LinkedinUrn",
  DoNotContact = "DoNotContact",
  Actions = "Actions",
  InsightsApprovedCount = "InsightsApprovedCount"
}

export type UngroupCompanyResponse = Omit<Company, "relationship"> & {
  relationship: RELATIONSHIP_TYPE;
};
